import * as React from 'react';

import {FieldArray} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import {PipelineFields} from './pipeline-fields';

export function LeadClosedForm() {
    return (
        <FormField innerId='leadClosed' label='Which pipeline?'>
            <FieldArray
                name='leadClosed'
                rerenderOnEveryChange={true}
                component={PipelineFields}
                formType='leadClosed'
            />
        </FormField>
    );
}
